if(document.querySelector('.trade-customer')) {
    var selectors = document.getElementsByClassName('vat-selectors');
    
    function changeVAT(vat) {
       var incVat = document.getElementsByClassName('price__current--inc');
       var exVat = document.getElementsByClassName('price__current--ex');

       if(vat == 'ex') {
        localStorage.setItem('vat', 'inc');
        for(const ex of exVat) {
            ex.classList.remove('hidden');
        }

        for(const inc of incVat) {
            inc.classList.add('hidden');
        }
       } else {
        localStorage.setItem('vat', 'inc');

        for(const ex of exVat) {
            ex.classList.add('hidden');
        }

        for(const inc of incVat) {
            inc.classList.remove('hidden');
        }
       }
    }

    if(localStorage.getItem('vat') != null) {
        changeVAT(localStorage.getItem('vat'));

        for(const selector of selectors) {
            selector.value = localStorage.getItem('vat');
        }

        setTimeout(() => {
            changeVAT(localStorage.getItem('vat')); 
        }, 2500);
    } else {
        localStorage.setItem('vat', 'inc');
    }


    for(const selector of selectors) {
        selector.addEventListener('change', function() {
            changeVAT(selector.value);
        });
    }
}


document.addEventListener('DOMContentLoaded', () => {
  const redirectIfWholesaleCartOpens = () => {
    const body = document.body;
    if (body.classList.contains('trade-customer') && body.classList.contains('cd-cart-is-open')) {
         body.classList.remove('cd-cart-is-open');
         setTimeout(function(){window.location.href = '/cart';},1000)
    }
  };

  // Run immediately if classes already exist
  redirectIfWholesaleCartOpens();

  // Observe changes to body class list
  const observer = new MutationObserver(() => redirectIfWholesaleCartOpens());
  observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });
});

